import { Component, inject } from '@angular/core';
import { OfficialPlannedPlantationPlantService } from '../proxy/operational/controllers';
import { ListService } from '@abp/ng.core';
import {
  ConfirmationService,
} from '@abp/ng.theme.shared';
import { OfficialPlannedPlantationPlantCreateDto, OfficialPlannedPlantationPlantUpdateDto } from '../proxy/operational/dtos/official-planned-plantation-plant';
import { OFFICIALPLANNEDPLANTATIONPLANT_CONFIG, OFFICIALPLANNEDPLANTATIONPLANT_FIELDS } from './official-planned-plantation-plant.config';
import { BaseHierarchicalCrudComponent, GenericForm, ICrudService, ZnHierarchicalViewComponent } from '@zendra/shared';
import { OfficialPlannedPlantationPlantPlanningOrchestratorService } from 'orchestrator/proxy';
import { GetOfficialPlannedPlantationPlantProjectionListInputDto, OfficialPlannedPlantationPlantProjectionDto, OfficialPlannedPlantationPlantProjectionExcelDownloadDto } from 'projects/orchestrator/src/lib/proxy/upm/zendra/cms/projection/official-planned-plantation-plants/models';

@Component({
  selector: 'app-official-planned-plantation-plant',
  imports: [GenericForm, ZnHierarchicalViewComponent],
  providers: [ListService, OfficialPlannedPlantationPlantService, ConfirmationService],
  templateUrl: './official-planned-plantation-plant.html',
  styleUrl: './official-planned-plantation-plant.scss',
})
export class OfficialPlannedPlantationPlant extends BaseHierarchicalCrudComponent<
  OfficialPlannedPlantationPlantProjectionDto,
  OfficialPlannedPlantationPlantCreateDto,
  OfficialPlannedPlantationPlantUpdateDto,
  OfficialPlannedPlantationPlantProjectionExcelDownloadDto
> {
  operationalService = inject(OfficialPlannedPlantationPlantService);
  orchestratorService = inject(OfficialPlannedPlantationPlantPlanningOrchestratorService);
  service: ICrudService<OfficialPlannedPlantationPlantProjectionDto, OfficialPlannedPlantationPlantCreateDto, OfficialPlannedPlantationPlantUpdateDto, OfficialPlannedPlantationPlantProjectionExcelDownloadDto> = {
    create: input => this.operationalService.create(input),
    update: (id, input) => this.operationalService.update(id, input),
    deleteByIds: ids => this.operationalService.deleteByIds(ids),
    getList: (query: GetOfficialPlannedPlantationPlantProjectionListInputDto) => this.orchestratorService.getList(query),
    getDownloadToken: () => this.orchestratorService.getDownloadToken(),
    getListAsExcelFile: input => this.orchestratorService.getListAsExcelFile(input),
    projectionConsistency: this.createProjectionConsistency(this.orchestratorService, 'officialPlannedPlantationPlantId'),
  };
  config = OFFICIALPLANNEDPLANTATIONPLANT_CONFIG;
  fields = OFFICIALPLANNEDPLANTATIONPLANT_FIELDS;

  protected override prepareCreateDto(data: any): OfficialPlannedPlantationPlantCreateDto {
    return {
      officialPlannedPlantationId: this.parentId!,
      plantId: data.plantId,
      plantTypeId: data.plantTypeId,
      speciesGroupId: data.speciesGroupId,
    };
  }

  protected prepareUpdateDto(data: any, selected: OfficialPlannedPlantationPlantProjectionDto): OfficialPlannedPlantationPlantUpdateDto {
    return {
      officialPlannedPlantationId: selected.officialPlannedPlantationId,
      plantId: data.plantId,
      plantTypeId: data.plantTypeId,
      speciesGroupId: data.speciesGroupId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'OfficialPlannedPlantationPlant';
  }
}
